export const TEMPALTE_GUBUN_MUTATION = "TEMPALTE_GUBUN_MUTATION";
